import { getIdFromText } from '@/utils/formatters';

/**
 * Matches paragraphs whose entire content is wrapped in `[toc]...[/toc]`
 * (e.g. `"[toc]Travel Perks[/toc]"`), promoting them to sub-section headings.
 * The inner text may be empty (`[toc][/toc]`) for untitled sub-sections —
 * those still get a letter label in the body but are skipped by the TOC.
 * Group 1 is the heading text inside the wrap.
 */
export const TOC_HEADING_RE = /^\s*\[toc\]\s*(.*?)\s*\[\/toc\]\s*$/;

/** Strips any opening or closing `[toc]` marker, along with adjacent whitespace, from a text segment. */
export const TOC_MARKER_RE = /\s*\[\/?toc\]\s*/g;

export function getTocAnchor(sectionAnchor: string, headingText: string, anchorCounts: Map<string, number>): string {
  const baseAnchor = `${sectionAnchor}-${getIdFromText(headingText)}`;
  const count = anchorCounts.get(baseAnchor) ?? 0;
  anchorCounts.set(baseAnchor, count + 1);

  if (count === 0) return baseAnchor;

  return `${baseAnchor}-${count + 1}`;
}
